// extracted by mini-css-extract-plugin
export default {"container":"fire_container__2uLxO"};